import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './index.css'

// Apply the saved theme before first paint so the shell never flashes.
const savedTheme = localStorage.getItem('wm-theme')
if (savedTheme === 'light' || savedTheme === 'dark') {
  document.documentElement.dataset.theme = savedTheme
}

const updateSW = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('wm:sw-update', { detail: { apply: () => updateSW(true) } }))
  },
  onRegisteredSW(_url, registration) {
    if (!registration) return
    // The browser only looks for a new service worker on navigation, and an
    // installed iOS PWA can stay alive for days without one — so updates were
    // only ever discovered on a cold start. Check whenever the app comes back
    // to the foreground, and hourly while it stays open.
    const check = () => void registration.update().catch(() => undefined)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check()
    })
    setInterval(check, 60 * 60 * 1000)
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
